import React, { Component } from 'react';
import NavBar from '../Components/NavBar/NavBar.js';
import './Catalogo.css';
import Footer from '../Components/Footer/Footer.js';
import pag2 from '../Images/Catalogo/pag2.jpg';
import pag3 from '../Images/Catalogo/pag3.jpg';
import pag4 from '../Images/Catalogo/pag4.jpg';
import pag6 from '../Images/Catalogo/pag6.jpg';
import pag7 from '../Images/Catalogo/pag7.jpg';
import pag8 from '../Images/Catalogo/pag8.jpg';
import pag9 from '../Images/Catalogo/pag9.jpg';
import pag10 from '../Images/Catalogo/pag10.jpg';
import pag11 from '../Images/Catalogo/pag11.jpg';
import pag12 from '../Images/Catalogo/pag12.jpg';
import pag13 from '../Images/Catalogo/pag13.jpg';
import pag16 from '../Images/Catalogo/pag16.jpg';
import pag18 from '../Images/Catalogo/pag18.jpg';
import pag19 from '../Images/Catalogo/pag19.jpg';
import pag20 from '../Images/Catalogo/pag20.jpg';
import pag24 from '../Images/Catalogo/pag24.jpg';
import pag27 from '../Images/Catalogo/pag27.jpg';
import pag28 from '../Images/Catalogo/pag28.jpg';
import pag33 from '../Images/Catalogo/pag33.jpg';
import pag34 from '../Images/Catalogo/pag34.jpg';
import pag35 from '../Images/Catalogo/pag35.jpg';
import FooterContatos from '../Components/Footer/FooterContatos.js';
import ButtonC from '../Components/ButtonCatalogo/ButtonC';
import FloatingWhatsApp from 'react-floating-whatsapp';
import LOGOL from '../Images/logo2.png';

class Motorredutores extends Component {
 render() {
 return (
   <div className="backGBlack">
   <NavBar/>
    <div className="EspacoBotoes"></div>
  <div className="ButtonsItens">
  <ButtonC/>
     </div>
     <div className="EspacoBotoes"></div>
   <div className="CatalogoPageCss">
    <img src={pag2} width="auto" alt="pag2"></img>
    <img src={pag3} width="auto" alt="pag3"></img>
    <img src={pag4} width="auto" alt="pag4"></img>
    <img src={pag6} width="auto" alt="pag6"></img>
    <img src={pag7} width="auto" alt="pag7"></img>
    <img src={pag8} width="auto" alt="pag8"></img>
    <img src={pag9} width="auto" alt="pag9"></img>
    <img src={pag10} width="auto" alt="pag10"></img>
    <img src={pag11} width="auto" alt="pag11"></img>
    <img src={pag12} width="auto" alt="pag12"></img>
    <img src={pag13} width="auto" alt="pag13"></img>
    <img src={pag16} width="auto" alt="pag16"></img>
    <img src={pag18} width="auto" alt="pag18"></img>
    <img src={pag19} width="auto" alt="pag19"></img>
    <img src={pag20} width="auto" alt="pag20"></img>
    <img src={pag24} width="auto" alt="pag24"></img>
    <img src={pag27} width="auto" alt="pag27"></img>
    <img src={pag28} width="auto" alt="pag28"></img>
    <img src={pag33} width="auto" alt="pag33"></img>
    <img src={pag34} width="auto" alt="pag34"></img>
    <img src={pag35} width="auto" alt="pag35"></img>
   </div>
   <div className="EspacoBotoes"></div>
   <Footer/>
   <FooterContatos/>
   <FloatingWhatsApp avatar={LOGOL} position="absolute" accountName="Centro Oeste" allowClickAway="true" placeholder="Escreva sua mensagem"  chatMessage="Olá, como posso te ajudar?" statusMessage="online" allowEsc="true" phoneNumber="5567998383492"/>
</div>
 );
 }
}
export default Motorredutores;